

var epochTime = 1761260399,
    date = epochTime * 1000,
    confettiCode = 'Mim0sa_Embargov3',
    countdownContainers = document.querySelectorAll('.countdown:not(.countdown-fake)');

function startCountdown(date, countdownContainer) {
  var daysWrapper = countdownContainer.querySelector('.time.days');
  var hoursWrapper = countdownContainer.querySelector('.time.hours');
  var minutesWrapper = countdownContainer.querySelector('.time.minutes');
  var secondsWrapper = countdownContainer.querySelector('.time.seconds');

  function updateCountdown() {

    const now = new Date().getTime();
    const timeRemaining = date - now;

    if (timeRemaining <= 0) {
      if(daysWrapper) { daysWrapper.textContent = '00'; }
      if(hoursWrapper) { hoursWrapper.textContent = '00'; }
      if(minutesWrapper) { minutesWrapper.textContent = '00'; }
      if(secondsWrapper) { secondsWrapper.textContent = '00'; }

      if(!localStorage.getItem('showConfetti' + confettiCode) || localStorage.getItem('showConfetti' + confettiCode) !== 'true') {
        startConfetti();

        setTimeout(function () {
          stopConfetti();
          location.reload();
        }, 5000);
      }

      localStorage.setItem('showConfetti' + confettiCode, 'true');

      clearInterval(interval);
      return;
    }

    const days = String(Math.floor(timeRemaining / (1000 * 60 * 60 * 24))).padStart(2, '0');
    const hours = String(Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0');
    const minutes = String(Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
    const seconds = String(Math.floor((timeRemaining % (1000 * 60)) / 1000)).padStart(2, '0');

    if(daysWrapper){ daysWrapper.textContent = days; }
    if(hoursWrapper){ hoursWrapper.textContent = hours; }
    if(minutesWrapper){ minutesWrapper.textContent = minutes; }
    if(secondsWrapper){ secondsWrapper.textContent = seconds; }
  }

  const interval = setInterval(updateCountdown, 1000);
  updateCountdown();
}

countdownContainers.forEach(function(countdownContainer) {
  startCountdown(date, countdownContainer);
});